import React from 'react';
import { useSelector } from 'react-redux';

const FullScreenLoader = () => {
    const loader = useSelector((state) => state.settings.loader)
    return (
        <div>
            <div className={loader + "LoadingOverlay d-none"}>
                <div className="Line-Progress">
                    <div className="indeterminate"></div>
                </div>
            </div>
        </div>
    );
};

export default FullScreenLoader;